// extracted by mini-css-extract-plugin
export var adjacentSlide = "_lw-9";
export var arrowButtonContainer = "_lw-5";
export var arrowButtonIcon = "_lw-6";
export var carouselArrowButton = "_lw-2";
export var carouselElementContainer = "_lw-1";
export var currentSlide = "_lw-8";
export var left = "_lw-3";
export var otherSlide = "_lw-a";
export var productCarouselContainer = "_lw-0";
export var right = "_lw-4";
export var sliderOverflow = "_lw-7";